module.exports = __webpack_public_path__ + "f678e08d4a03638faa80f16d1452a3ed.pdf";